// extracted by mini-css-extract-plugin
export default {"container":"Navigation_container__Iiul6","link":"Navigation_link__FidFE","disabledLink":"Navigation_disabledLink__8fFcq"};